export default __webpack_public_path__ + "static/media/italy.9ef80c6c.svg";